export default function setupStoreTracking() {
  const iosLinks = document.querySelectorAll('.app-store-link');
  const androidLinks = document.querySelectorAll('.play-store-link');

  if (gon.app_env === 'production') {
    iosLinks.forEach((link) => {
      link.addEventListener('click', () => {
        if (!gon.accepted_cookies) {
          return;
        }

        fbq('track', 'ViewContent', { content_name: 'App Store' });
      });
    });

    androidLinks.forEach((link) => {
      link.addEventListener('click', () => {
        if (!gon.accepted_cookies) {
          return;
        }

        fbq('track', 'ViewContent', { content_name: 'Play Store' });
      });
    });
  }
}
